import React, { PureComponent } from "react";

import "./Input.less";

class Input extends PureComponent {
  static defaultProps = {
    className: "",
    placeholder: "",
  };

  render() {
    const { className, placeholder, ...props } = this.props;
    return (
      <input
        className={`Input-component ${className}`}
        placeholder={placeholder}
        {...props}
      />
    );
  }
}

export default Input;
